import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppConstants } from './AppConstants';
import { CapacitorPlatformService } from './service/capacitor-platform.service';
import { AuthService } from './service/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { UIRoutes } from './UIRoutes';
import { LoginModalService } from './login-modal.service';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { ForceUpdateService } from './service/force-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  currentUser;
  updateCheckComplete = false;
  forceUpdateRequired = false;
  private routerSubscription;
  // http://ec2-3-108-63-28.ap-south-1.compute.amazonaws.com
  constructor(
    private capacitorPlatformService: CapacitorPlatformService,
    private authService: AuthService,
    private router: Router,
    private loginModalService: LoginModalService,
    public forceUpdateService: ForceUpdateService
  ){
    this.authService.restorePersistentLogin();
    this.currentUser = sessionStorage.getItem(AppConstants.SESSION_STORAGE_ACCESS_TOKEN);
    this.authService.syncUserContext();
  }

  async ngOnInit() {
    this.capacitorPlatformService.init();

    this.forceUpdateRequired = await this.forceUpdateService.initialize();
    this.updateCheckComplete = true;
    if (this.forceUpdateRequired) {
      return;
    }

    if (this.capacitorPlatformService.isNative()) {
      GoogleAuth.initialize();
    }

    if (this.capacitorPlatformService.isNative() && !this.authService.isLoggedIn()) {
      this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_LOGIN).then(() => {
        setTimeout(() => {
          this.loginModalService.setLoginModalData(true);
        });
      });
      return;
    }

    this.authService.syncUserContext();

    this.routerSubscription = this.router.events.subscribe(event => {
      if (
        event instanceof NavigationEnd &&
        this.authService.isLoggedIn()
      ) {
        this.authService.syncUserContext();

        this.redirectUserToLandingPage();
      }
    });

    // Before initial navigation, router.url is '/' even when the WebView opened a payment URL.
    // Let that navigation finish before deciding whether the user needs a default landing page.
    if (this.router.navigated) {
      this.redirectUserToLandingPage();
    }
  }

  private redirectUserToLandingPage(): void {
    if (!this.authService.isLoggedIn() || !this.shouldRedirectUserToLandingPage()) {
      return;
    }

    const roleId = Number(AppConstants.SESSION_STORAGE_ROLEID);

    if (roleId === 3) {
      this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_PRODUCT_ALL);
    } else if (roleId === 2) {
      this.router.navigateByUrl(
        `${UIRoutes.ROUTING_MODULE_LANDING_PAGE}/${UIRoutes.ROUTING_MODULE_DASHBOARD}`
      );
    } else if (roleId === 1) {
      this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_TENANTS_GRID);
    }
  }

  private shouldRedirectUserToLandingPage(): boolean {
    const currentUrl = this.router.url.split('?')[0].split('#')[0];

    return !currentUrl ||
      currentUrl === '/' ||
      currentUrl === '/home' ||
      currentUrl === `/${UIRoutes.ROUTING_MODULE_LOGIN}` ||
      currentUrl === UIRoutes.ROUTING_MODULE_SIGN_UP_SUCCESS ||
      currentUrl === `/${UIRoutes.ROUTING_MODULE_SIGN_UP_SUCCESS.replace('/', '')}` ||
      currentUrl === `/${UIRoutes.ROUTING_MODULE_LOGIN_SUCCESS}`;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
      this.routerSubscription = undefined;
    }

    this.capacitorPlatformService.destroy();
  }
}
